<div class="popup-container">
    <div class="popup-model">
        <div class="popup-header">
            <div class="popup-header-text">{{headerTitle}}</div>
            <div class="popup-close" (click)="close()" title="Close"></div>
        </div>
        <div class="popup-body">
            <div class="popup-scrollable-content">
                <div class="inputText">
                    <label for="title">Title</label>
                    <input type="text" id="title" placeholder="Enter your report name" [(ngModel)]="report.title" >
                </div>

                <div class="inputText">
                    <!-- Selection Summary -->
                    <label for="summary">Selection Summary</label>
                    <textarea rows="4" id="sumary" [(ngModel)]="report.selectionSummary"></textarea>
                </div>
                <div class="inputText">
                    <!-- Experience Textarea -->
                    <label for="experience">Tell us about your experience
                        <span class="micicon">
                            <img src="assets/images/common/aesthetics/mic-icon.svg" alt="icon" />
                        </span>
                    </label>
                    <textarea rows="5" id="experience" [(ngModel)]="report.description"></textarea>
                </div>
                <div class="inputText">
                    <!-- File Upload Section -->
                    <div class="file-upload-container">
                        <input type="file" id="fileInput" multiple (change)="onFileSelected($event)" hidden />
                        <label style="width:100%;height: 100%;" for="fileInput" class="file-upload-box">
                            <div class="file-container">
                                <span class="file-icon"><img src="assets/images/common/aesthetics/uploadfile-icon.svg"
                                        alt="Attachment" /></span>
                                <p>Choose A File Or Drag And Drop</p>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="inputText">

                    <div class="file-list">
                        <div class="file-list-item" *ngFor="let file of files">
                            <div class="file-name">{{file.name}}</div>
                            <div class="file-remove" (click)="removeFile(file)">X</div>
                        </div>
                    </div>
                </div>
                <div class="inputText">
                        <button class="record-btn">
                            <img src="assets/images/common/aesthetics/recordIcon.svg" alt="record screen"
                                class="btn-icon" /><span class="recordbtn-txt">Record Screen</span></button>
                </div>            
                <p *ngIf="uploadSizeExceed" style="color:red">*Uploaded files exceeds limit 10MB</p>
            </div>
            <div class="modal-footer">
                <button class="submit-btn" (click)="submitReport()" [disabled]="!report.title || report.title.trim() === ''">
                    <img src="assets/images/common/aesthetics/submit-icon.svg" alt="Submit" class="btn-icon" />Submit
                    Report</button>
            </div>
        </div>

    </div>
</div>